import Vue from "vue";

Vue.mixin({
  created() {
    document.title = "FairFinder";
  }
});
